import React, { Fragment, Suspense,useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { base_url } from "./Constants";
import { fetchHomePageData } from "../redux/stateSlice/homePageSlice";
import { useParams } from "react-router-dom";
import axios from "axios";
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const ContactOne = React.lazy(() => import("../components/ContactOne"));
const FaqOne = React.lazy(() => import("../components/FaqOne"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const PartnerOne = React.lazy(() => import("../components/PartnerOne"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const Faq = () => {
  const {lang,id} = useParams();
    const [data,setData] =  useState({});
    const [related,setRelated] = useState([]);
    const [loading,setLoading] = useState(false);
    useEffect(()=>{
            axios.get(base_url+`/api/faq`,{
              headers:{
                language:'ar'
              }
            }).then(response=>{
              setLoading(true);
              setData(response.data.data)
              setRelated(response.data.related);
            })
        },[]);
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}

          {/* Breadcrumb */}
          {data && (
            <>
              <NavbarOne og_title={data.name}  og_image={base_url+'/'+data.image} />
              <Breadcrumb title={data.name} header_bg={base_url+'/'+data.image}  />
              {/* Faq One */}
              <div className='faq-area pd-top-120 pd-bottom-120'>
                <FaqOne  data={data}  />
              </div>
            </>)}
          

          {/* Contact One */}
          <div
            className='call-to-contact-area pd-top-140  mt-0'
            style={{ background: "#F9F9F9" }}
          >
            <ContactOne />
          </div>

          {/* Partner One */}
          <PartnerOne />

          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>{" "}
      </Fragment>
    </>
  );
};

export default Faq;
